import React, { useState, useEffect } from "react";
import { useForm, Controller } from "react-hook-form";
import {
  Button,
  FormControl,
  Select,
  Grid,
  InputLabel,
  TextField,
  MenuItem,
  FormHelperText,
} from "@material-ui/core";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { useStateValue } from "../../context/store";
import { stylePublicVac } from "./style-public-vacancie";
import { defaultSearchValues } from "./headers";
import TitleCase from "react-title-case";
import { getActivePublicRegionals } from "../../actions/regional-actions";
import{getPublicChargesByStatusActive}from"../../actions/charge-actions"

const SearchPublicVacancie = () => {
  const classes = stylePublicVac();
  const _ = require("lodash");
  const [{}, dispatch] = useStateValue();

  const schema = yup.object().shape({
    salaryMin: yup.number().when([], {
      is: (salaryMin) => salaryMin && salaryMin > 0,
      then: yup.number(),
      otherwise: yup
        .number()
        .nullable(true)
        .notRequired()
        .transform((v) => (v ? v : null)),
    }),
    salaryMax: yup.number().when([], {
      is: (salaryMax) => salaryMax && salaryMax > 0,
      then: yup.number(),
      otherwise: yup
        .number()
        .nullable(true)
        .notRequired()
        .transform((v) => (v ? v : null)),
    }),
    charge: yup.string().when([], {
      is: (charge) => charge && charge.length > 0,
      then: yup.string(),
      otherwise: yup
        .string()
        .nullable(true)
        .notRequired()
        .transform((v) => (v ? v : null)),
    }),
    regional: yup.string().when([], {
      is: (regional) => regional && regional.length > 0,
      then: yup.string(),
      otherwise: yup
        .string()
        .nullable(true)
        .notRequired()
        .transform((v) => (v ? v : null)),
    }),
  });

  const [regionales, setRegionales] = useState([]);
  const [charges, setCharges] = useState([]);

  useEffect(() => {
    const getRegionales = async () => {
      const response = await getActivePublicRegionals();
      let orderRegionales = _.sortBy(
        response.data && response.data.regionalList,
        (o) => o.name
      );
      setRegionales(orderRegionales);
    };
    getRegionales();
  }, []);

  useEffect(() => {
    const getPublicChargesByStatusActiveAsync = async () => {
      const response = await getPublicChargesByStatusActive();
      let orderCharges = _.sortBy(
        response.data && response.data.chargeList,
        (o) => o.name
      );
      setCharges(orderCharges);
    };
    getPublicChargesByStatusActiveAsync();
  }, []);




  const { register, handleSubmit, control, errors, setValue } = useForm({
    resolver: yupResolver(schema),
    defaultSearchValues,
    mode: "onChange",
    reValidateMode: "onChange",
  });

  const onSubmit = (data) => {
    if (
      data.regional !== null ||
      data.salaryMin !== null ||
      data.salaryMax !== null ||
      data.charge !== null
    ) {
      dispatch({
        type: "SET_PUBLIC_VACANCY_FILTER",
        filter: data,
        isFilter: true,
      });
    }
  };

  const clearForm = () => {
    setValue("regional", null);
    setValue("salaryMin", null);
    setValue("salaryMax", null);
    setValue("charge", null);
  };

  const clearBtn = () => {
    clearForm();
    dispatch({
      type: "SET_PUBLIC_VACANCY_FILTER",
      filter: {
        salaryMin: null,
        salaryMax: null,
        charge: null,
        regional: null,
      },
      isFilter: true,
    });
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <Grid container spacing={2}>
        <Grid item xs={12} md={2} lg={2}>
          <FormControl
            variant="outlined"
            fullWidth
            size="small"
            error={
              !!errors.hasOwnProperty("regional") && errors["regional"].message
            }
          >
            <InputLabel htmlFor="outlined-select-regional" shrink={true}>
              Regional
            </InputLabel>
            <Controller
              fullWidth
              control={control}
              inputRef={register}
              label="Regional"
              className={classes.inputForm}
              size="small"
              name="regional"
              notched={true}
              defaultValue={null}
              inputProps={{
                name: "regional",
                id: "outlined-select-regional",
              }}
              as={
                <Select>
                  <MenuItem
                    className={classes.menuItem}
                    aria-label="None"
                    value={null}
                  >
                    <em>&nbsp;</em>
                  </MenuItem>
                  {regionales.map((op) => (
                    <MenuItem
                      className={classes.menuItem}
                      key={op.id}
                      value={op.id}
                    >
                      <TitleCase string={op.name} />
                    </MenuItem>
                  ))}
                </Select>
              }
            />
            <FormHelperText>
              {errors.hasOwnProperty("regional") && errors["regional"].message}
            </FormHelperText>
          </FormControl>
        </Grid>

        <Grid item xs={12} md={2} lg={2}>
          <FormControl fullWidth>
            <TextField
              fullWidth
              variant="outlined"
              inputRef={register}
              InputLabelProps={{ shrink: true }}
              className={classes.inputForm}
              type="number"
              autocomplete="off"
              label="Salario Min"
              name="salaryMin"
              size="small"
              error={
                errors.hasOwnProperty("salaryMin") &&
                errors["salaryMin"].message
              }
            />
            <FormHelperText style={{ color: "#f44336", paddingLeft: 14 }}>
              {errors.hasOwnProperty("salaryMin") &&
                errors["salaryMin"].message}
            </FormHelperText>
          </FormControl>
        </Grid>

        <Grid item xs={12} md={2} lg={2}>
          <FormControl fullWidth>
            <TextField
              fullWidth
              variant="outlined"
              inputRef={register}
              InputLabelProps={{ shrink: true }}
              className={classes.inputForm}
              type="number"
              autocomplete="off"
              label="Salario Max"
              name="salaryMax"
              size="small"
              error={
                errors.hasOwnProperty("salaryMax") &&
                errors["salaryMax"].message
              }
            />
            <FormHelperText style={{ color: "#f44336", paddingLeft: 14 }}>
              {errors.hasOwnProperty("salaryMax") &&
                errors["salaryMax"].message}
            </FormHelperText>
          </FormControl>
        </Grid>

        <Grid item xs={12} md={2} lg={2}>
          <FormControl
            variant="outlined"
            fullWidth
            size="small"
            error={
              !!errors.hasOwnProperty("charge") && errors["charge"].message
            }
          >
            <InputLabel htmlFor="outlined-select-charge" shrink={true}>
              Cargo
            </InputLabel>
            <Controller
              fullWidth
              control={control}
              inputRef={register}
              label="Cargo"
              className={classes.inputForm}
              size="small"
              name="charge"
              notched={true}
              defaultValue={null}
              inputProps={{
                name: "charge",
                id: "outlined-select-charge",
              }}
              as={
                <Select>
                  <MenuItem
                    className={classes.menuItem}
                    aria-label="None"
                    value={null}
                  >
                    <em>&nbsp;</em>
                  </MenuItem>
                  {charges.map((op) => (
                    <MenuItem
                      className={classes.menuItem}
                      key={op.id}
                      value={op.id}
                    >
                      <TitleCase string={op.denomination} />
                    </MenuItem>
                  ))}
                </Select>
              }
            />
            <FormHelperText>
              {errors.hasOwnProperty("charge") && errors["charge"].message}
            </FormHelperText>
          </FormControl>
        </Grid>

        <Grid
          item
          xs={12}
          md={3}
          lg={3}
          style={{ textAlign: "left", paddingLeft: "20px" }}
        >
          <Button
            variant="contained"
            className={classes.buttonSearch}
            type="submit"
          >
            Buscar
          </Button>
          &nbsp;&nbsp;
          <Button
            variant="contained"
            className={classes.buttonSearch}
            type="submit"
            onClick={clearBtn}
          >
            Limpiar
          </Button>
        </Grid>
      </Grid>
    </form>
  );
};

export default SearchPublicVacancie;
